import { IXepLoaiChungChiActionTypes } from "../../action-types/category/IXepLoaiChungChiActions";
import { IXepLoaiChungChiReducer } from "../../reducer-model/category/IXepLoaiChungChiReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const iniState: IXepLoaiChungChiReducer = {
    status: eReducerStatusBase.is_not_initialization,
    xepLoaiChungChis: [],
}

export const XepLoaiChungChiReducer = (state = iniState, action: IXepLoaiChungChiActionTypes): IXepLoaiChungChiReducer => {
    switch (action.type) {
        case "XEP_LOAI_CHUNG_CHI_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "XEP_LOAI_CHUNG_CHI_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                xepLoaiChungChis: action.payload,
            };
        case "XEP_LOAI_CHUNG_CHI_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "XEP_LOAI_CHUNG_CHI_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                xepLoaiChungChiEditing: action.payload,
            };
        case "XEP_LOAI_CHUNG_CHI_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            };
        case "XEP_LOAI_CHUNG_CHI_SAVE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving,
            };
        case "XEP_LOAI_CHUNG_CHI_SAVE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
                isShowEditModal: false,
            };
        case "XEP_LOAI_CHUNG_CHI_SAVE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "XEP_LOAI_CHUNG_CHI_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting,
            };
        case "XEP_LOAI_CHUNG_CHI_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "XEP_LOAI_CHUNG_CHI_DELETE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        default:
            return state;
    }
}